<template>
    <span>
        <span :class="change ? 'icon has-text-danger' : 'icon has-text-dark'" 
            v-if="isAdmin" >
                <i class="fas fa-paragraph"></i>
        </span>
       
        <div class="slabel" 
            @contextmenu="openModal($event)">
           <div :class="isAdmin ? 'slabelEdit ql-editor' : 'slabel ql-editor'" v-html="labelRef()"></div>
        </div>
        <div :ref="'label_'+id" style="display:none">
                <slot></slot>
        </div>
    </span>
</template>
<style scoped>
    .slabel {
        display: inline-block;
        padding: 0;
        margin: 0;
        overflow: hidden;
    }
    .slabelEdit {
        display: inline-block;
        padding: 0;
        margin: 0;
        overflow: hidden;
    }
    .slabelEdit:hover {
        cursor: pointer;
        border: thin black dashed;
    }
</style>
<script>

export default {
    props:['id','v'],
    data() {
        return {
            openModalText: false,
            displayText: '',
            labelOrigin: '',
            change: false
        }
    },
    watch: {
        v: {
             immediate: true, 
             handler(val, old) {
               this.initLabelOrigin();
             }
        },
        id : {
            immediate: true, 
            handler(val,old) {
                this.initLabelOrigin();
            }
        },
        getLabels: {
            immediate: true, 
            handler(val,old) {
                this.initLabelOrigin();
            }
        }
    },
    computed: {
        getLabels: {
            get() {
                return this.$store.getters.getLabelRef;
            }
        },
        isAdmin: {
            get() {
                if (this.$store.getters.getUser) {
                    if (typeof(this.$store.getters.getUser.adminSite)!="undefined")
                        return this.$store.getters.getUser.adminSite;
                    else
                        return false;
                }
                else    
                    return false
            }
        },
    },
    methods: {
        labelRef() {
            
                var label = null;
                            
                var labels = this.$store.getters.getLabelRef;
                if (labels!=null) {
                    if (typeof(labels[this.id])=="undefined")
                        label = this.labelOrigin;
                    else
                        label =  labels[this.id];
                }
                //this.labelOrigin = label;
                label = this.parse(label, this.v);
                return label;
            
        },
         parse(str) {
            var args = [].slice.call(arguments, 1),
                i = 0;
            return str.replace(/%v/g, () => args[i++]);
        },
        notMenu(e) {
            e.preventDefault();
        },
        openModal(e){
            e.preventDefault();
            if (this.$store.getters.getUser.adminSite) {
                this.labelOrigin = this.returnLabelOrigin();
                var text="";
                text = this.labelOrigin;
                this.$store.dispatch("editorOnOff", {
                    value: text,
                    id: this.id
                }, ()=>{

                });
            }
        },
        returnLabelOrigin() {
            var label = null;
                var labels = this.$store.getters.getLabelRef;
                if (labels!=null) {
                        if (typeof(labels[this.id])=="undefined") {
                            this.change = false;
                            if (typeof(this.$refs['label_'+this.id])!="undefined")
                                label =  this.$refs['label_'+this.id].innerHTML;
                            
                        }
                        else {
                            this.change = true;
                            label =  labels[this.id];
                        }
                }
                return label;
        },
        initLabelOrigin() {
            this.$nextTick(()=>{
                 this.labelOrigin = this.returnLabelOrigin();
            })
        }
       
    },
    mounted() {
        this.initLabelOrigin();
    }
}
</script>